import React from 'react'

class TagView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { children, className, innerRef, ...restProps } = this.props;
        return <div
            ref={innerRef}
            className={className}
            {...restProps}
        >
            {children}
        </div>
    }
}

const Tag = React.forwardRef((props, ref) => {
    return <TagView {...props} innerRef={ref} />;
});

export default Tag;